import {
    SeatGridService,
    OrderService,
    MovieService,
    RegionService,
    PageService,
    AuthService
} from 'hasta-la-vista-middleware-api/service'
import {Utils} from 'hasta-la-vista-ui-core'
import {LoyaltyCard} from 'hasta-la-vista-middleware-api/model'


export default {

    data() {
        return {
            loading: false,
            loadingLoyalties: false,
            loadingAnotherMovie: false,
            loadingUpdateOrder: false,
            updateOrderLoading: false,
            toggleDialog: false,
            cancelAddOrderDialog: false,
            dialogMsg: undefined,
            seatingDialog: false,
            order: null,
            seats: null,
            seatGrid: [],
            movies: [],
            areas: null,
            maxTickets: 19,
            selectedSeats: [],
            showMovieAdder: false,
            selectedMovie: null,
            selectedExperience: null,
            selectedDate: null,
            selectedSession: null,
            cinemaType: null,
            rows: [],
            currentCinema: null,
            cinema_id: null,
            session_id: null,
            seatSelectable: true,
            maxTotal: 5000, 
            screen_name: null,
            cinema_name: null,
            subsComboDialog: false,
            facebookPixelSKShow: false,
            floodLightShow: false,
            floodlightPixel: null,
            validators: [
                {
                    message: "<strong>Movies are best enjoyed together</strong>. Please choose seats that don’t leave a single space.",
                    test: ()=> {
                        return true; //remove gap rule 
                        for (let i = 0; i < Object.keys(this.order.Session.positions).length; i++) {
                            let row = Object.keys(this.order.Session.positions)[i];

                            let position = this.order.Session.positions[row];
                            position.sort((a, b) => parseFloat(a) - parseFloat(b))
                            let lastPos = undefined;
                            for (var j = 0; j < position.length; j++) {
                                var thisPos = position[j];
                                if (lastPos) {
                                    let Difference = Math.abs(thisPos - lastPos);
                                    if (Difference > 1) return false;
                                }
                                lastPos = thisPos;
                            }
                        }

                        return true;
                    }
                },
                {
                    message: "The companion seat is for a wheelchair assistant. You unfortunately cannot book this seat without booking a wheelchair seat as well.",
                    test: ()=> {

                        return true; //remove rule
                        let foundWheelChair = false;
                        let foundCompanion = false;
                        for (let i = 0; i < this.order.Session.Tickets.length; i++) {
                            let ticket = this.order.Session.Tickets[i];
                            if (ticket.status.wheelchair == true) foundWheelChair = true;
                            if (ticket.status.companion == true) foundCompanion = true;
                        }
                        if (foundCompanion && !foundWheelChair)
                            return false;
                        else
                            return true;
                    }
                },
                {
                    message: "Hmm, looks like there are more Movie Cards than seats. Please add seats or remove Movie Cards to continue with your booking.",
                    test: ()=> !(this.order.Session.Loyalties.length > this.order.Session.Tickets.length)

                },
                {
                    message: "You can only use your Edgars card for two movie tickets.",
                    test: ()=> {
                        let numTicketsPerCard = {};
                        for (let i = 0; i < this.order.Session.Loyalties.length; i++) {
                            var loyalty = this.order.Session.Loyalties[i];
                            if (loyalty.TicketType.ThirdPartyMembershipName == "Edgars Redemption") {
                                numTicketsPerCard[loyalty.MemberCard] = numTicketsPerCard[loyalty.MemberCard] || 0;
                                numTicketsPerCard[loyalty.MemberCard]++;
                                if (numTicketsPerCard[loyalty.MemberCard] > 2) return false;
                            }
                        }
                        return true;
                    }

                },

                {
                    message: "You can only use your Vitality card once per Movie.",
                    test: ()=> {
                        let numTicketsPerCard = {};
                        for (let i = 0; i < this.order.Session.Loyalties.length; i++) {
                            var loyalty = this.order.Session.Loyalties[i];
                            if (~loyalty.TicketType.ThirdPartyMembershipName.toLowerCase().indexOf("vitality")) {
                                numTicketsPerCard[loyalty.MemberCard] = numTicketsPerCard[loyalty.MemberCard] || 0;
                                numTicketsPerCard[loyalty.MemberCard]++;
                                if (numTicketsPerCard[loyalty.MemberCard] > 1) return false;
                            }
                        }
                        return true;
                    }

                },

                {
                    message: "Please select at least one seat to continue.",
                    test: ()=> this.order.Session.Tickets.length > 0
                },
                {
                    test: ()=> {
                        let success = true,
                            message = "One or more cards requires more seats than you have available";
                        for (let loyalty of this.order.Session.Loyalties) {
                            let requirements = loyalty.TicketType.PackageContent;
                            // console.log
                            if (requirements && requirements.Tickets.length > 0) {
                                let quantity = 1;
                                let fourForThree = false;
                                for(let i in requirements.Tickets) {
                                    if(requirements.Tickets[i].Description.includes("4FOR3")) {
                                        fourForThree = true
                                    }
                                }

                                if(fourForThree) {
                                    for (let requirement of requirements.Tickets) {
                                        if (requirement.Quantity) quantity += requirement.Quantity;
                                    }
                                    if (this.order.Session.Tickets.length < quantity) {
                                        success = false;
                                        let qMessage = ` ${quantity} tickets, in addition to any other loyalty seats you have selected.`;
                                        message = `In order to use the ${loyalty.TicketType.Description} recognition, you need at least ${qMessage}`
                                    }
                                }
                            }
                        }

                        return {success: success, message: message};
                    }
                }

            ],
            festival: null,
        }
    },

    computed: {
        regions(){
            return [{name: 'Nearby', cinemas: this.cinemasNearBy}].concat(this.regionsRaW)
        },

        sessionsForCinema(){
            return this.selectedExperience ? this.selectedMovie.cinemas[this.cinema_id].filter((s)=>~s.experiences.findIndex((e)=>e.name == this.selectedExperience)) : [];
        },

        availableDates(){
            let avail = this.sessionsForCinema.reduce((c, session)=> {
                var obj = {
                    string: `${session.show_time.additional.string_long_day_of_week} ${session.show_time.additional.string_nth_day} ${session.show_time.additional.string_long_month}`,
                    show_time: session.show_time
                };
                !(~c.findIndex((c)=>c.string === obj.string)) && c.push(obj);
                return c;
            }, [])

            if (!this.selectedDate && avail.length > 0) this.setSelectedDate(avail[0].show_time.date)
            return avail;
        },

        availableSessions(){

            let sessions = this.selectedDate && this.sessionsForCinema.length > 0 ? this.sessionsForCinema.filter((session)=>session.show_time.date.format('YYYY-MM-DD') === this.selectedDate.format('YYYY-MM-DD')) : [];
            // console.log("availableSessions", sessions)
            if (!this.selectedSession && sessions.length > 0) this.setSelectedSession(sessions[0])
            return sessions
        },

        canBook(){
            return !!(this.selectedSession)
        },

        seatCount() {
            return (this.maxTickets - this.order.Tickets.length)
        },

        moviesGrouped(){
            let filmFestivals = this.order ? this.order.Sessions.reduce((c, s)=> {
                if (s.movie)
                    c = c.concat(s.movie.film_festivals)
                return c;
            }, []) : [];

            if (filmFestivals.length > 0) {
                let sessionMovies = this.order.Sessions.map((s)=>s.movie.id);
                let ffMovies = this.movies.filter((m)=>filmFestivals.find((f)=>m.film_festivals.includes(f)) && !~sessionMovies.indexOf(m.id))
                let nMovies = this.movies.filter((m)=>!ffMovies.includes(m) && !~sessionMovies.indexOf(m.id));
                return [{name: 'Related Film Festival Movies:', movies: ffMovies}, {
                    name: 'Other Movies Now Showing',
                    movies: nMovies
                }];
            }

            return []
            // if (this.festival) {
            //     return [{
            //         name: `${this.festival.title} Cinemas`,
            //         cinemas: this.festival.Cinemas.filter((c)=>~Object.keys(this.movie.cinemas).indexOf(c.id))
            //     }]
            // }
            // return [{name: 'Near By', cinemas: this.cinemasNearBy}].concat(this.regionsRaW)

        },

        fanLoyaltyCountAdded() {
            let count = 0

            if(this.order != undefined && this.order != null) {
                if(this.order.Session.Loyalties != undefined && this.order.Session.Loyalties != null) {
                    for(let i = 0; i <= this.order.Session.Loyalties.length; i++) {
                        if(this.order.Session.Loyalties[i] != undefined && this.order.Session.Loyalties[i] != null) {
                           // console.log(this.order.Session.Loyalties[i].TicketType.Description) 

                           if(this.order.Session.Loyalties[i].TicketType.Description.includes('Fan Club') && this.order.Session.Loyalties[i].TicketType.Description.includes('Combo')) {
                                count++
                           }
                        }
                        

                    }    
                }
            }

            return count
        },

        morviesLoyaltyCountAdded() {
            let count = 0

            if(this.order != undefined && this.order != null) {
                if(this.order.Session.Loyalties != undefined && this.order.Session.Loyalties != null) {
                    for(let i = 0; i <= this.order.Session.Loyalties.length; i++) {
                        if(this.order.Session.Loyalties[i] != undefined && this.order.Session.Loyalties[i] != null) {
                           // console.log(this.order.Session.Loyalties[i].TicketType.Description) 

                           if(this.order.Session.Loyalties[i].TicketType.Description.includes('MORvies') && this.order.Session.Loyalties[i].TicketType.Description.includes('Combo')) {
                                count++
                           }
                        }
                        

                    }    
                }
            }

            return count
        },
    },


    methods: {

        getStatus(session){
            var status = true;
            if (session.seats_available == 0) {
                status = false;
            }
            return status
        },

        getStatusString(session){
            var status = '';
            if (session.seats_available <= 10) {
                status = 'Limited Seats Available'
            } else if (session.seats_available == 0) {
                status = 'Sold Out'
            }
            return status;

        },

        setNearByCinemas (place) {
            RegionService.getCinemasNearBy(place.latitude, place.longitude).then((cinemasNearBy)=> {

                    cinemasNearBy.length = 5; //restrict number of results to 5;

                    this.cinemasNearBy = cinemasNearBy;

                }
            );
        },

        setSelectedDate(date){
            this.selectedDate = this.selectedDate === date ? null : date;
            this.selectedSession = null;
        },

        setSelectedSession(session){
            // console.log("session", session)
            if (this.getStatus(session))
                this.selectedSession = this.selectedSession === session ? null : session;
        },

        selectable(seat) {
            if(this.seatSelectable) {
                if (this.seatCount > 0 && ~(this.seatCount - seat.seats.length)) {
                    this.seatSelectable = true
                    return true;
                } else {
                    this.seatingDialog = true
                    this.seatSelectable = false
                    return false
                }
            } else {
                return false
            }
        },

        setSeat(seat, isActive, canceller){
            for (var i = 0; i < seat.seats.length; i++) {
                var thisSeat = seat.seats[i];
                if (!thisSeat.ticket && isActive) {
                    thisSeat.ticket = this.order.addTicket(thisSeat, seat);
                } else if (thisSeat.ticket) {
                    this.order.removeTicket(thisSeat.ticket);
                    thisSeat.ticket = undefined;
                } else if (seat.ticket) {
                    this.order.removeTicket(seat.ticket);
                    seat.ticket = undefined;
                }
            }

            if(!this.seatSelectable) {
                this.seatSelectable = true
            }
        },

        setSelectedExperience(exp){
            this.selectedExperience = exp;
            this.selectedDate = null;
            this.selectedSession = null;
        },

        tearDownAddOrder(){
            this.selectedSession = null;
            this.selectedMovie = null;
            this.selectedExperience = null;
            this.selectedDate = null;
            this.selectedDate = null;
        },

        addOrder(){
            this.loading = true;
            this.showMovieAdder = false;
            window.scroll({top: 0, left: 0})
            OrderService.addToOrder(this.selectedSession.id, this.cinema_id, this.selectedMovie.id).then((order)=> {

                if (!this.order.Session.SeatGridPromise)
                    this.order.loadSeatGrid().then(()=>this.loading = false, ()=>this.loading = false);
                else this.loading = false;
                this.tearDownAddOrder()
            }, ()=> {
                this.loading = false;
                this.updateOrderLoading = false
            });

        },

        cancelAddOrder(){
            this.tearDownAddOrder()
            this.showMovieAdder = false;
            this.cancelAddOrderDialog = false
        },

        showAddMovieForm(){
            RegionService.getCinema(this.cinema_id).then((cinema)=> {
                this.currentCinema = cinema.name
            })
            this.loadingAnotherMovie = true;
            this.validate().then(()=> {
                Promise.all([RegionService.getRegions(), MovieService.getMovies(), MovieService.getFilteredMovies({cinemas: [this.cinema_id]}),])
                    .then(([regions,movieDetails])=> {
                        let sessionMovies = this.order.Sessions.map((s)=>s.movie.id);
                        this.movies = movieDetails.data.filter((m)=>!~sessionMovies.indexOf(m.id) && (m.cinemas[this.cinema_id] && m.cinemas[this.cinema_id].length > 0));
                        if (this.$route.params.festival_id) {
                            this.movies = movieDetails.data.filter((m)=> {
                                return m && ~m.film_festivals.indexOf(this.$route.params.festival_id) ? true : false
                            })
                        }

                        if (this.order.modified) {
                            OrderService.saveTickets().then((order)=> {
                                window.scroll({top: 0, left: 0})
                                this.loadingAnotherMovie = false
                                this.showMovieAdder = true;
                                this.order.loadSeatGrid()
                            })
                        } else {
                            window.scroll({top: 0, left: 0})
                            this.loadingAnotherMovie = false;
                            this.showMovieAdder = true;
                        }


                    })
            }, (error)=> {
                this.loading = false;
                this.loadingAnotherMovie = false;
                this.dialogMsg = "Please ensure your booking is valid before adding another movie <br> " + error;
                this.toggleDialog = true;
            })
        },

        validate(){
            return new Promise((resolve, reject)=> {
                for (let i = 0; i < this.validators.length; i++) {
                    let validator = this.validators[i];
                    let passed = validator.test();
                    var message = passed.message || validator.message;
                    var passed = typeof passed === 'boolean' ? passed : passed.success;

                    if (passed === false) {
                        return reject(message)
                    }
                }
                resolve(true);
            })

        },

        updateOrder(){
            // console.log(this.order)
            this.updateOrderLoading = true;
            this.subsComboDialog = false;
            if (!this.order.modified && this.order.hasTickets) {
                this.$router.push(`/booking/2${this.$route.params.festival_id ? '/film-festival/' + this.$route.params.festival_id : ''}`);
                // window.location.href = '/booking/2'
            } else {

                this.validate().then(()=> {
                    OrderService.saveTickets().then((order)=> {
                        this.loading = false;
                        this.$router.push(`/booking/2${this.$route.params.festival_id ? '/film-festival/' + this.$route.params.festival_id : ''}`);
                    });
                }, (error)=> {
                    this.updateOrderLoading = false;
                    this.dialogMsg = error;
                    this.toggleDialog = true;
                })

            }


        },

        facebookPixelSK() {
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '700460340621505');
            fbq('track', 'PageView');

            this.facebookPixelSKShow = true
        },

        floodlightBlackWidow(movie_id) {
            if(movie_id == "HO00001971") {
              this.blackWidowFloodLightShow = true;
              gtag('event', 'conversion', {
                'allow_custom_scripts': true,
                'send_to': 'DC-4347362/sterk00/sterk0+unique'
              });
            } else {
                this.blackWidowFloodLightShow = false;
            }
        },

        floodlightInit(movie) {
            if(movie.floodlight_tag != undefined) {
                if(movie.floodlight_tag.length > 0) {
                    var a = eval(movie.floodlight_tag)
                    this.floodLightShow = true;
                    this.floodlightPixel = movie.floodlight_pixel
                } else {
                    this.floodLightShow = true;
                }
            } else {
                this.floodLightShow = false;
            }
        }

    },

    created() {
        this.loading = true;
        this.loadingLoyalties = true;
        this.updateOrderLoading = false

        OrderService.getOrder()
            .then((order)=> {
                this.order = order;
                this.cinema_id = order.CinemaId;
                this.session_id = order.SessionId;

                

                Promise.resolve(MovieService.findBySessionId(order.SessionId,order.CinemaId)).then((movie) => {
                    console.log("movie", movie)
                    // console.log("movie_id", movie.id)
                    // this.floodlightBlackWidow(movie.id)
                    this.floodlightInit(movie)
                });


                this.facebookPixelSK();

                // console.log("order", order.Session)

                if(order.Session.MovieSession.cinema != undefined)
                    this.screen_name = order.Session.MovieSession.screen_name
                // this.screen_name = this.screen_name.replace("CINE ", "Cinema")
                if(order.Session.MovieSession.cinema != undefined)
                    this.cinema_name = order.Session.MovieSession.cinema.name

                this.order.loadSeatGrid().then(()=> {

                    // if (!this.order.Tickets || this.order.Tickets.length == 0) {
                    this.order.Session.SeatGrid.mapTicketsToGrid(this.order.Tickets);
                    // }

                    this.loading = false
                });

                if (this.$route.params.festival_id)
                    PageService.getFilmFestivals().then((festivals)=> {
                        this.festival = festivals.find((f)=>f.nid === this.$route.params.festival_id);

                    })

            });

    },

    mounted(){
        window.scroll({top: 0, left: 0})
    },

    watch: {
        selectedMovie(el) {
            if (el) this.selectedExperience = el.getExperienceForCinema(this.cinema_id)[0]
            else this.selectedExperience = null

            this.selectedDate = null;
            this.selectedSession = null;

        }
    }
}



// WEBPACK FOOTER //
// ./src/components/booking/seating/seating.js